<template>
  <kst-container class="kst-stockreduction-details">
    <kst-form
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :loading="isLoading"
      :title="title"
      :warnings="formWarnings"
    >
      <template #top-right>
        <Action :data="data"/>
      </template>

      <b-tabs v-model="activeTab" size="is-medium" type="is-boxed">
        <b-tab-item :label="tabs.Details">
          <Details :data="data"/>
          <Items :data="data" :items="data.Items"/>
          <Total :data="data"/>
        </b-tab-item>
        <b-tab-item :label="tabs.HppDetails">
          <HppDetails :items="data.Items"/>
          <HppTotal :data="data"/>
        </b-tab-item>
      </b-tabs>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../StockReductionInfo.js";
import Model from "../StockReductionModel.js";
import Services from "../StockReductionServices.js";

import Action from "./StockReductionDetails_Action";
import Details from "./StockReductionDetails_Details";
import HppDetails from "./StockReductionDetails_HppDetails";
import HppTotal from "./StockReductionDetails_HppTotal";
import Items from "./StockReductionDetails_Items";
import Total from "./StockReductionDetails_Total";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Action,
    Details,
    HppDetails,
    HppTotal,
    Items,
    Total
  },
  data: () => ({
    data: {},
    itemsSummary: [],
    deliveryList: [],
    isLoading: false,
    // tabs
    activeTab: 0,
    tabs: {
      Details: Info.Tabs.Details,
      HppDetails: Info.Tabs.HppDetails
    },
    // error
    formWarnings: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Details_ParamIncomplete];
        return;
      }

      this.data = {};
      this.itemsSummary = [];

      this.initLoad(id);
    },
    initLoad(id) {
      this.isLoading = true;
      this.failureInit = null;

      this.loadDetails(id);
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadDetails(id) {
      const config = Services.getStockReductionDetailsData(id);
      this.runAxios(config, null,
        this.loadDetails_Success,
        this.loadDetails_Error,
        this.loadDetails_Invalid
      );
    },
    loadDetails_Success(data) {
      this.setDetails(data);
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },
    loadDetails_Invalid(message) {
      this.formWarnings = [message];
      this.initLoad_End();
    },

    setDetails(data) {
      this.data = data.Details;
      for (const item of this.data.Items) {
        Model.updateItemByPackaging(item);
      }

      Model.updateDetailsByDetailsData(this.data, data);
    }
  }
}
</script>